var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iv-card",class:_vm.status,style:(_vm.style)},[_c('span',{staticClass:"iv-inline-block"},_vm._l((_vm.data),function(item,i){return _c('div',{key:i},[_vm._v(_vm._s(item))])}),0),(_vm.showCloseBtn)?_c('Icon',{staticClass:"iv-close",attrs:{"type":"close-circled"},on:{"click":_vm.onClose}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }